import React from "react";
import "../styles/Features.css";

const features = [
  {
    img: "/service1.png",
    title: "Fixed-Term Deposits",
    desc: "Preserve and grow your capital with secure, time-bound deposits. Choose from leading global currencies and enjoy competitive, guaranteed returns with Swiss-grade stability.",
    link: "/services/fixed",
  },
  {
    img: "/service5.png",
    title: "Foreign Currency Accounts",
    desc: "Open and manage multi-currency accounts in USD, EUR, GBP, and CHF. Enjoy seamless global transfers and transparent exchange rates — wherever your wealth moves.",
    link: "/services/foreign",
  },
  {
    img: "/service4.png",
    title: "Private World Elite Card",
    desc: "Access a bespoke Mastercard designed for discerning clients. Enjoy priority services, airport lounge access, and exclusive global privileges curated by Swiss financial experts.",
    link: "/services/elite",
  },
  {
    img: "/service3.png",
    title: "Multi-Currency Savings",
    desc: "Diversify your savings across international markets. Manage up to 25 currencies from a single secure platform, optimized for expats, entrepreneurs, and global investors.",
    link: "/services/savings",
  },
];

export default function Features() {
  return (
    <section className="features">
      <h2 className="features-heading">Offshore solutions crafted with Swiss precision</h2>
      <div className="features-grid">
        {features.map((item, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-img">
              <img src={item.img} alt={item.title} />
            </div>
            <div className="feature-content">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
              <a href={item.link} className="feature-link">
                Learn more &rsaquo;
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
